module.exports = __webpack_public_path__ + "img/green.06f2b3d8.jpg";